import { html } from "src/components/HtmlViewer/utils";
import * as GQL from "src/types/graphql";

export const OFFER_REVOKED = {
  type: GQL.message_template_type_enum.OfferRevoked,
  emailSubject:
    "Your offer from {{offer.schoolName}} has been revoked / Su oferta de {{offer.schoolName}} ha sido revocada",
  emailHtml: html`<p>
      Dear {{parent.name}},<br />
      <br />
      Your offer from {{offer.schoolName}} for {{student.name}}, for grade
      {{grade}} for the {{enrollmentPeriod.name}} has been revoked by an
      administrator.<br />
      <br />
      If you have questions, please contact {{organization.name}}. You can
      review the status of {{student.name}}'s form anytime: {{applyUrl}}<br />
      <br />
      -{{organization.name}} Team<br />
    </p>
    <p>_____________________________________________</p>
    <p>
      Estimado/a {{parent.name}},<br />
      <br />
      Ha sido revocada una oferta de {{offer.schoolName}} para {{student.name}},
      para el grado {{grade}} para el {{enrollmentPeriod.name}}.<br />
      <br />
      Si necesita ayuda, por favor contacte a {{organization.name}}. Puede
      revisar el estado de la aplicación de {{student.name}} en cualquier
      momento: {{applyUrl}}<br />
      <br />
      -Equipo de {{organization.name}}<br />
    </p>`,
  emailText: `Dear {{parent.name}},

Your offer from {{offer.schoolName}} for {{student.name}}, for grade {{grade}} for the {{enrollmentPeriod.name}} has been revoked by an administrator.

If you have questions, please contact {{organization.name}}. You can review the status of {{student.name}}'s form anytime: {{applyUrl}}

-{{organization.name}} Team

_____________________________________________

Estimado/a {{parent.name}},

Ha sido revocada una oferta de {{offer.schoolName}} para {{student.name}}, para el grado {{grade}} para el {{enrollmentPeriod.name}}.

Si necesita ayuda, por favor contacte a {{organization.name}}. Puede revisar el estado de la aplicación de {{student.name}} en cualquier momento: {{applyUrl}}

-Equipo de {{organization.name}}`,
  sms: "Your offer from {{offer.schoolName}} has been revoked / Su oferta de {{offer.schoolName}} ha sido revocada.",
};
